import { render } from "./SuggestedCompetitorsModal.vue?vue&type=template&id=5264c5fd&scoped=true"
import script from "./SuggestedCompetitorsModal.vue?vue&type=script&lang=js"
export * from "./SuggestedCompetitorsModal.vue?vue&type=script&lang=js"

import "./SuggestedCompetitorsModal.vue?vue&type=style&index=0&id=5264c5fd&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5264c5fd"]])

export default __exports__